export const HOME_FAV_ROW_LIMIT = 30;

export function favoritesForRow(favAlbums, expanded) {
  return expanded ? favAlbums : favAlbums.slice(0, HOME_FAV_ROW_LIMIT);
}
